import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const LANGUAGES = [
  { value: "en", label: "English" },
  { value: "de", label: "Deutsch" },
  { value: "nl", label: "Dutch" },
  { value: "el", label: "Ελληνικά" },
  { value: "sl", label: "Slovenščina" },
];

function LanguageSwitcher() {
  const { t } = useTranslation();
  const { i18n } = useTranslation();

  const [selectedLanguage, setSelectedLanguage] = useState(null);

  useEffect(() => {
    if (!i18n.language) {
      // detect browser language
      const browserLanguage = navigator?.language?.split("-")[0]; // z.B. 'de' aus 'de-DE'

      const defaultLanguage =
        LANGUAGES.find((lang) => lang?.value === browserLanguage) ||
        LANGUAGES[0]; // Fallback auf Englisch

      i18n.changeLanguage(defaultLanguage?.value);
      setSelectedLanguage(defaultLanguage);
    } else {
      const currentLanguage = LANGUAGES.find(
        (lang) => lang?.value === i18n.language,
      );

      setSelectedLanguage(currentLanguage);
    }
  }, [i18n]);

  const changeLanguage = (selectedOption) => {
    i18n.changeLanguage(selectedOption.value);
    setSelectedLanguage(selectedOption);
  };

  return (
    <Select
      value={selectedLanguage}
      onChange={changeLanguage}
      options={LANGUAGES}
      menuPortalTarget={document.body}
      placeholder={t("select_language")}
      className="custom-select"
      classNamePrefix="custom-select"
    />
  );
}

export default LanguageSwitcher;
